import _objectSpread from'@babel/runtime/helpers/objectSpread2';import _toConsumableArray from'@babel/runtime/helpers/toConsumableArray';import _asyncToGenerator from'@babel/runtime/helpers/asyncToGenerator';import _regeneratorRuntime from'@babel/runtime/regenerator';var sha256Hash = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldToHash) {
    var encoder, data, hashBuffer, hashArray, hashHex;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            encoder = new TextEncoder();
            data = encoder.encode(fieldToHash);
            _context.next = 4;
            return crypto.subtle.digest('SHA-256', data);
          case 4:
            hashBuffer = _context.sent;
            /*global Uint8Array*/
            hashArray = _toConsumableArray(new Uint8Array(hashBuffer));
            hashHex = hashArray.map(function (byte) {
              return byte.toString(16).padStart(2, '0');
            }).join('');
            return _context.abrupt("return", hashHex);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function sha256Hash(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getPageData = function getPageData(pageName, language) {
  var pageData = {
    pageName: pageName,
    type: 'transactional',
    siteType: 'CWS',
    brand: 'Manulife',
    loB: 'Manulife ID',
    plataform: 'CIAM',
    segment: 'CA',
    country: 'CA',
    title: document.title,
    domain: window.location.hostname,
    path: window.location.pathname,
    pageURL: window.location.href,
    userAgent: window.navigator.userAgent,
    botDetector: window.navigator.webdriver,
    language: language,
    previousPageData: document.referrer || null,
    pageNavPosition: document.documentElement.scrollTop || document.body.scrollTop
  };
  return pageData;
};
var getUserData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userInfo) {
    var medallia, emailHashed, ecid, userData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            medallia = function medallia() {
              try {
                return sessionStorage.getItem('Feedback_UUID') || null;
              } catch (error) {
                return null;
              }
            };
            if (!userInfo.email) {
              _context2.next = 7;
              break;
            }
            _context2.next = 4;
            return sha256Hash(userInfo.email);
          case 4:
            _context2.t0 = _context2.sent;
            _context2.next = 8;
            break;
          case 7:
            _context2.t0 = null;
          case 8:
            emailHashed = _context2.t0;
            ecid = function ecid() {
              try {
                return window._satellite.getVisitorId().getMarketingCloudVisitorID() || null;
              } catch (error) {
                return null;
              }
            };
            userData = _objectSpread(_objectSpread({
              anonymousID: ecid(),
              primaryCustomerID: userInfo.hashedCiamId
            }, emailHashed && {
              emailAddressHashed: emailHashed
            }), {}, {
              type: userInfo.userAuth !== 'authenticated' ? 'Visitor' : 'Customer',
              subType: userInfo.userType
            }, medallia() && {
              medalliaUUID: medallia()
            });
            return _context2.abrupt("return", userData);
          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function getUserData(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getAnalytics = function getAnalytics() {
  var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (clear) {
    window.adobeDataLayer = [];
  } else {
    window.adobeDataLayer = window.adobeDataLayer || [];
  }
  return window.adobeDataLayer;
};export{getAnalytics,getPageData,getUserData};